import axios from "axios";
import { API_URL } from "../constants/constants.js";
import router from "@/router";
import { authClient } from "@/helpers/authClient";

// Cliente Axios con el interceptor configurado
const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Importante para Better Auth: enviar cookies seguras
});

// Interceptor de respuestas para manejar errores de autenticación
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;

    // Plan upgrade required — show notification, don't retry
    if (status === 403 && error.response?.data?.code === 'PLAN_UPGRADE_REQUIRED') {
      import('notiflix').then(({ Notify }) => {
        Notify.warning('Esta funcionalidad requiere el plan Pro. Contacta a soporte para mejorar tu plan.');
      });
      return Promise.reject(error);
    }

    if (status === 401) {
      // 401 means unauthenticated/invalid session in Better Auth
      // limpiar estado local y redirigir de inmediato
      localStorage.removeItem('auth');
      sessionStorage.removeItem('auth');
      if (router.currentRoute.value.name !== "Login") {
        router.replace("/login");
      }

      // intentar cerrar sesión en backend sin bloquear la navegación
      try {
        authClient.signOut();
      } catch (e) {
        // ignore
      }
    }
    return Promise.reject(error);
  }
);

// Recorre todas las páginas de un endpoint paginado ({ data, pagination })
// y devuelve el listado completo. El backend limita cada página a `limit`,
// por lo que una sola llamada nunca trae más de esa cantidad de registros.
export async function fetchAllPages(url, params = {}, pageSize = 200) {
  const MAX_PAGES = 100; // tope de seguridad
  const items = [];
  let page = 1;
  let totalPages = 1;

  do {
    const { data } = await apiClient.get(url, {
      params: { ...params, page, limit: pageSize },
    });
    items.push(...(data?.data || []));
    totalPages = data?.pagination?.totalPages || 1;
    page++;
  } while (page <= totalPages && page <= MAX_PAGES);

  return items;
}

export default apiClient;
